import api from "@/api";

const EventModule = {
    state: () => ({ all: [], single: null, isLoading: false }),
    mutations: {
        ADD_ALL_EVENTS(state, payload) {
            state.all.splice(0, state.all.length, ...payload);
        },
        UPDATE_SINGLE_EVENT(state, payload) {
            state.single = payload;
        },
    },
    actions: {
        async getAllEvents(context) {
            const content = await api.EventApi.getAll();
            context.commit("ADD_ALL_EVENTS", content.data);
        },
        async getSignleEvent(context, payload) {
            const content = await api.EventApi.getSingle(payload);
            context.commit("UPDATE_SINGLE_EVENT", content.data);
        },
    },
    getters: {},
    namespaced: true,
};
export default EventModule;
